export default __webpack_public_path__ + "static/media/avatar6.fa7dd653.png";